/* eslint-disable import/prefer-default-export */
// import axios from 'axios';
import makeRequest from 'utils/makeRequest';
import reducerRegistry from '../../reduxUtils/reducerRegistry';

const reducerName = 'common';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const SET_SLIKE_PREVIEW_ID = createActionName('SET_SLIKE_PREVIEW_ID');
export const SET_RUNTIME_VARIABLE = createActionName('SET_RUNTIME_VARIABLE');
export const TOGGLE_OPEN_IN_APP = createActionName('TOGGLE_OPEN_IN_APP');
export const RECEIVE_VARIANT_DATA = createActionName('RECEIVE_VARIANT_DATA');
export const UPDATE_CAIMPAIGN_ADS_CONFIG = createActionName(
  'UPDATE_CAIMPAIGN_ADS_CONFIG',
);
export const SET_THEME_BY_OPTIMIZELY = createActionName(
  'SET_THEME_BY_OPTIMIZELY',
);
export const SET_SITE_CONFIG = createActionName('SET_SITE_CONFIG');
export const SET_CPD_CONFIG = createActionName('SET_CPD_CONFIG');

export const SET_SOCIAL_SHARE_STATE = createActionName(
  'SET_SOCIAL_SHARE_STATE',
);

export const SET_GUTTER_FALLBACK = createActionName('SET_GUTTER_FALLBACK');
export const RECEIVE_SITE_CLIENT_CONFIG = createActionName(
  'RECEIVE_SITE_CLIENT_CONFIG',
);

export function setSlikePreviewID(msid, index) {
  return {
    type: SET_SLIKE_PREVIEW_ID,
    payload: {
      slikeId: msid,
      index,
    },
  };
}

export function setRuntimeVariable({ name, value }) {
  return {
    type: SET_RUNTIME_VARIABLE,
    payload: {
      name,
      value,
    },
  };
}

export function toggleOpenInApp(isShown) {
  return {
    type: TOGGLE_OPEN_IN_APP,
    payload: {
      isShown,
    },
  };
}
export function setThemeByOptimizely(newTheme) {
  return {
    type: SET_THEME_BY_OPTIMIZELY,
    payload: {
      newTheme,
    },
  };
}

export function setSocialShareTrayStatus(status) {
  return {
    type: SET_SOCIAL_SHARE_STATE,
    payload: {
      status,
    },
  };
}

export function setGutterFallback(showGutterFallback, gutterFallbackAdObject) {
  return {
    type: SET_GUTTER_FALLBACK,
    payload: {
      showGutterFallback,
      gutterFallbackAdObject,
    },
  };
}
function callSiteClientConfigApi() {
  const feedUrl = '/site_global_config/feedtype-sjson.cms';
  return makeRequest.get(feedUrl, {}, 'skipfeedengine');
}
function fetchCPDConfig() {
  const url =
    'https://s3-ap-southeast-1.amazonaws.com/toiassets/js/expresso_json.js';
  return makeRequest.get(
    url,
    {
      params: {},
    },
    'skipfeedengine',
  );
}
function fetchSiteConfig() {
  const endpoint = '/site_settings/feedtype-json.cms';
  return makeRequest.get(
    endpoint,
    {
      params: {},
    },
    'skipfeedengine',
  );
}

function receiveSiteConfig(data) {
  return {
    type: SET_SITE_CONFIG,
    payload: {
      data,
    },
  };
}

function handleSiteConfigError() {
  return {
    type: SET_SITE_CONFIG,
    payload: {
      data: {},
    },
  };
}
function receiveUpdatedAdConfig(data) {
  return {
    type: UPDATE_CAIMPAIGN_ADS_CONFIG,
    payload: data,
  };
}

export function updateCaimpaignAdsConfig(jarvisconfig) {
  return dispatch => dispatch(receiveUpdatedAdConfig(jarvisconfig));
}
export function getSiteConfig() {
  return dispatch =>
    fetchSiteConfig()
      .then(data => {
        dispatch(receiveSiteConfig(data.data));
      })
      .catch(error => {
        dispatch(handleSiteConfigError(error));
      });
}
export function receiveCPDConfig(data, tmpl) {
  // eslint-disable-next-line camelcase
  let isAtfCPd = 0;
  if (tmpl === 'home') {
    isAtfCPd = data.isTopBanner_HP_mWEB;
  } else {
    isAtfCPd = data.isTopBanner_ROS_mWEB;
  }
  return {
    type: SET_CPD_CONFIG,
    payload: { isAtfCPd },
  };
}
function handleCPDError() {
  return {
    type: SET_CPD_CONFIG,
    payload: {},
  };
}

export function getCPDConfig() {
  return dispatch =>
    fetchCPDConfig()
      .then(data => {
        dispatch(receiveCPDConfig(data.data));
      })
      .catch(error => {
        dispatch(handleCPDError(error));
      });
}

function receiveSiteClientConfigApi(data) {
  return {
    type: RECEIVE_SITE_CLIENT_CONFIG,
    payload: {
      ...data,
    },
  };
}

export function loadSiteClientConfigApi() {
  return dispatch =>
    callSiteClientConfigApi().then(response => {
      const { data = {} } = response;
      dispatch(receiveSiteClientConfigApi(data));
    });
}

export function receiveVariantData(data) {
  return {
    type: RECEIVE_VARIANT_DATA,
    payload: data,
  };
}

export default function reducer(state = {}, action) {
  switch (action.type) {
    case SET_RUNTIME_VARIABLE:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    case TOGGLE_OPEN_IN_APP:
      return {
        ...state,
        openInAppBtnVisible: action.payload.isShown,
      };
    case SET_THEME_BY_OPTIMIZELY:
      return {
        ...state,
        newTheme: action.payload.newTheme,
      };
    case SET_SITE_CONFIG:
      return {
        ...state,
        siteConfig: action.payload.data,
      };
    case SET_CPD_CONFIG:
      return {
        ...state,
        cpdConfig: action.payload,
      };
    case SET_SOCIAL_SHARE_STATE: {
      return {
        ...state,
        socialShareTrayStatus: action.payload.status,
      };
    }
    case SET_GUTTER_FALLBACK: {
      return {
        ...state,
        showGutterFallback: action.payload.showGutterFallback,
        gutterFallbackAdObject: action.payload.gutterFallbackAdObject,
      };
    }
    case RECEIVE_SITE_CLIENT_CONFIG: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case SET_SLIKE_PREVIEW_ID: {
      return {
        ...state,
        slikePreview: action.payload,
      };
    }
    case UPDATE_CAIMPAIGN_ADS_CONFIG: {
      return {
        ...state,
        siteConfig: {
          ...state.siteConfig,
          revenue: action.payload,
        },
      };
    }
    case RECEIVE_VARIANT_DATA: {
      return {
        ...state,
        variant: action.payload,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
